DJ.addBehavior('is-visible', '.main', {
  attach: function(context, settings, behavior) {
    function isScrolledIntoView(elem) {
      var docViewTop = jQuery(window).scrollTop();
      var docViewBottom = docViewTop + jQuery(window).height();

      var elemTop = jQuery(elem).offset().top;
      var elemBottom = elemTop + jQuery(elem).height() / 2;

      return ((elemTop <= docViewBottom) || (docViewTop >= elemBottom));
    }
    jQuery('.animated-container').each(function () {
      jQuery(this).css({'--scrollTop': jQuery(window).scrollTop() - jQuery(this).offset().top  + 'px'})
      if (isScrolledIntoView(this) === true) {
        jQuery(this).addClass('visible');
      } else {
        jQuery(this).removeClass('visible');
      }
    });
    jQuery(window).on('scroll', function () {
      jQuery('.animated-container').each(function () {
        jQuery(this).css({'--scrollTop': jQuery(window).scrollTop() - jQuery(this).offset().top + 'px'})
        if (isScrolledIntoView(this) === true) {
          jQuery(this).addClass('visible');
        } else {
          jQuery(this).removeClass('visible');
        }
      });
    });
  },

  detach: function(context, settings) {}
});
